<template>
  <div class="setting">
    <div class="page-header">
      <i class="back-icon" @click="$router.go(-1)"></i>
      <span>Settings</span>
    </div>
    <div class="content">
      <p class="title">Personal Settings</p>
      <div class="item">Clear Cache</div>
      <div class="item">Account Deletion</div>
      <div class="item" @click="handleLogin">Login with Google</div>
      <p class="title">Other Settings</p>
      <div class="item" @click="$router.push('/about')">About Us</div>
      <div class="item" @click="openUrl('terms')">Terms</div>
      <div class="item" @click="openUrl('privacy')">Privacy</div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      urlList: {
        privacy: 'https://toonfrenzy.com/privacy.html',
        terms: 'https://toonfrenzy.com/terms.html',
      },
    };
  },
  methods: {
    handleLogin() {
      this.$login();
    },
    openUrl(key) {
      if (!key) return;
      window.location.href = this.urlList?.[key] ?? '';
    },
  },
};
</script>
<style lang="less" scoped>
.setting {
  height: 100vh;
  .page-header {
    display: flex;
    align-items: center;
    color: @black;
    font-size: @fontLarge;
    font-weight: 700;
    height: 44px;
    padding: 0 16px;
    .back-icon {
      margin-right: 10px;
      .iconMixin({
        background-image: url('~@/assets/images/icon/back.png');
      });
    }
  }
  .content {
    padding: 0 16px;
    .title {
      padding-top: 16px;
      color: @gray;
      font-size: 14px;
      line-height: 24px;
    }
    .item {
      font-size: 16px;
      line-height: 56px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &::after {
        content: '';
        width: 24px;
        height: 24px;
        background: url('~@/assets/images/icon/arrow.png') no-repeat center;
        background-size: 24px;
      }
    }
  }
}
</style>
